module.exports = __webpack_public_path__ + "img/32913cb1-4d17-4b9a-bd94-5291f6aadaf9.381091b1.png";